<template>
  <div>
    <!--begin::Chart-->
    <apexchart
      class="statistics-widget-3-chart card-rounded-bottom"
      :options="options"
      :series="series"
      :height="300"
      type="bar"
    ></apexchart>
    <!--end::Chart-->
  </div>
</template>

<script>
export default {
  props: ["data", "studentName", "subject", "classLevel"],
  computed: {
    shouldShowExclus() {
      const level = this.classLevel;
      return level > 6;
    },
  },
  data() {
    return {
      options: {},
      series: [],
      labelColor: "#3F4254",
      colors: ["#D9214Ebb", "#ffc107bb", "#800080bb"],
      lightColors: ["#D9214E", "#ffc107", "#800080"],
    };
  },

  watch: {
    data: function (value) {
      this.updateChart();
    },

    studentName: function (value) {
      this.updateChart();
    },

    subject: function () {
      this.updateChart();
    },

    classLevel: function () {
      this.updateChart();
    },

    classLevel: function () {
      this.updateChart();
    },
  },

  created() {
    this.updateChart();
  },

  methods: {
    updateChart() {
      const attendance = this.data.filter((att) => {
        if (!this.subject) return true;
        if (!att.schedule || !att.schedule.subject) return false;
        const subjectName = att.schedule.subject.name || att.schedule.subject;
        return subjectName == this.subject;
      });

      let a = 0;
      let d = 0;
      let e = 0;
      attendance.forEach((att) => {
        if (att.type == "Retard") d++;
        else if (att.type == "Absence") a++;
        else if (att.type == "Exclus" && this.shouldShowExclus) e++;
      });

      const serie = this.shouldShowExclus ? [a, d, e] : [a, d];
      const types = this.shouldShowExclus
        ? [this.$t("assiduite.absence"), this.$t("assiduite.retard"), this.$t("assiduite.exclus")]
        : [this.$t("assiduite.absence"), this.$t("assiduite.retard")];

      this.updateOptions(types);
      this.updateSeries(serie);
    },

    updateSeries(serie) {
      const colors = this.shouldShowExclus
        ? this.colors
        : this.colors.slice(0, 2);
      this.series = [
        {
          data: serie,
          name: "",
          colors: colors,
        },
      ];
    },
    updateOptions(types) {
      this.options = {
        chart: {
          height: 300,
          type: "bar",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: this.colors,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        stroke: {
          curve: "smooth",
          show: true,
          width: 3,
          colors: this.colors,
        },
        xaxis: {
          type: "string",
          categories: types,
          labels: {
            show: false,
            style: {
              colors: this.labelColor,
              fontSize: "12px",
            },
          },
        },
        yaxis: [
          {
            labels: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
        tooltip: {
          style: {
            fontSize: "12px",
          },
          y: {},
        },
        fill: {
          colors: this.colors,
        },
        colors: this.colors,
        markers: {
          colors: this.colors,
          strokeColor: this.lightColors,
          strokeWidth: 3,
        },
      };
    },
  },
};
</script>
